import { Flex, Layout, Spin } from 'antd'
import React from 'react'
import IntervenerForm from './IntervenerForm'
import SMSPanel from '../SMSPanel/SMSPanel'
import { useForm } from 'antd/es/form/Form'

export default function IntervenerPage ({ intervener, loading, setLoading, setIntervener }) {
  const [form] = useForm()

  return (
    <Layout style={{ padding: '1em', backgroundColor: 'white', marginTop: '2em', justifyContent: 'space-between' }}>
      <Spin spinning={loading}>
        <Flex justify='space-around'>
          <IntervenerForm form={form} intervener={intervener} setLoading={setLoading} action="update"/>
          <div style={{ width: '30%' }}><SMSPanel owner={intervener} ownerType="interveners" setOwner={setIntervener} /></div>
        </Flex>
      </Spin>
    </Layout >
  )
}
